<template>
	<div class="my-index">
		<el-row :gutter="10" style="margin-bottom: 10px">
			<el-col :span="17">
				<a-card style="height: 150px; background: #e8f1ff">
					<div>
						<p>
							欢迎回来，
							<span style="font-weight: bold; font-size: 19px">{{ accountInfo.account_name }}</span>
						</p>
						<p style="font-size: 12px">{{ version_desc }}</p>
					</div>
					<div>
						<!--  <el-button type="primary" @click="gotoNewEvents"
              >新建活动</el-button
            > -->
						<a-button type="primary" @click="gotoNewEvents">
							<template #icon><PlusOutlined /></template>

							创建会议
						</a-button>
					</div>
				</a-card>
			</el-col>
			<el-col :span="7">
				<a-card style="height: 150px">
					<!-- <el-row>
						<el-col :span="12">
							<div>
								<span v-if="accountInfo.accountType == 'free'" style="font-weight: bold">免费版</span>
								<span class="account-type" v-else>
									<el-icon style="color: gold; font-size: 25px; vertical-align: middle"><GoldMedal /></el-icon>
									专业版
								</span>
							</div>
						</el-col>
						<el-col :span="12">
							<el-button
								v-if="accountInfo.accountType !== 'enterprise'"
								@click="accountTypeShow = true"
								style="background: #faf2dc; border-radius: 20px; color: orange; font-size: 16px; width: 130px; height: 30px"
							>
								升级版本
							</el-button>
							<el-button v-else style="background: #faf2dc; border-radius: 20px; color: orange; font-size: 16px; width: 130px; height: 30px">已升级</el-button>
						</el-col>
					</el-row> -->

					<div style="margin-top: 20px; display: flex; justify-content: space-around">
						<div>
							<p style="font-size: 14px">会议场次</p>
							<p style="color: green; font-size: 14px">
								{{ statisticInfo.eventsMaxNum ? statisticInfo.eventsMaxNum : '不限制' }}
							</p>
						</div>
						<div>
							<p style="font-size: 14px">单场注册人数</p>
							<p style="color: green; font-size: 14px">
								{{ statisticInfo.registNum }}
							</p>
						</div>
						<div>
							<p style="font-size: 14px">剩余时间</p>
							<p style="color: green; font-size: 14px">{{ statisticInfo.remainDays }}天</p>
						</div>
					</div>
				</a-card>
			</el-col>
		</el-row>
		<el-row :gutter="10">
			<el-col :span="17">
				<a-card style="height: 130px; margin-bottom: 10px">
					<el-row :gutter="10">
						<el-col style="text-align: center" :span="5">
							<div class="rejectClass" style="border-top: 49px solid var(--primary-color)">
								<div class="rejectSpan">进行中</div>
							</div>
							<a-card :body-style="{}">
								<h2>{{ statisticInfo.doingHuiyiCount }}</h2>
							</a-card>
						</el-col>
						<el-col style="text-align: center" :span="5">
							<div class="rejectClass">
								<div class="rejectSpan">本月活动</div>
							</div>
							<a-card>
								<h2>{{ statisticInfo.monHuiyiCount }}</h2>
							</a-card>
						</el-col>
						<el-col style="text-align: center" :span="5">
							<div class="rejectClass" style="border-top: 49px solid #303133">
								<div class="rejectSpan">本周活动</div>
							</div>
							<a-card>
								<h2>{{ statisticInfo.weekHuiyiCount }}</h2>
							</a-card>
						</el-col>

						<el-col style="text-align: center" :span="5">
							<div class="rejectClass" style="border-top: 49px solid rgb(238, 238, 238)">
								<div class="rejectSpan" style="color: black">已结束</div>
							</div>
							<a-card>
								<h2>{{ statisticInfo.finishHuiyiCount }}</h2>
							</a-card>
						</el-col>
					</el-row>
				</a-card>

				<a-card style="height: calc(100vh - 430px)" :body-style="{ padding: '10px' }">
					<template #title><span>最近会议</span></template>
					<template #extra><span style="cursor: pointer" @click="gotoEvents">更多</span></template>
					<el-row v-if="dataList && dataList.length > 0">
						<el-col v-for="d in dataList" :key="d.id" style="border-bottom: 1px solid #eee; margin-bottom: 4px">
							<a-card hoverable :body-style="{ padding: '10px' }">
								<el-row :gutter="5">
									<el-col :span="4" style="text-align: left">
										<!-- <img
											:src="d.会议图片"
											style="max-height: 120px; height: 100%; width: 100%"
											:style="{
												filter: d.huiyi_status == -1 ? 'grayscale(100%)' : ''
											}"
										/> -->
										<a-image
											v-if="d.会议图片"
											width="100%"
											height="120px"
											
											:style="{
												filter: d.huiyi_status == -1 ? 'grayscale(100%)' : ''
											}"
											:src="d.会议图片"
										/>
										<a-image
											v-else
											width="100%"
											height="120px"
											:style="{
												filter: d.huiyi_status == -1 ? 'grayscale(100%)' : ''
											}"
											src="data:image/png;base64,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"
										/>
									</el-col>
									<el-col :span="10" style="text-align: left">
										<div style="margin-bottom: 10px">
											<span
												style="font-weight: bold; font-size: 17px"
												:style="{
													color:
														d.huiyi_status == 1
															? 'var(--primary-color)'
															: d.huiyi_status == -1
															? 'rgb(153, 153, 153)'
															: d.huiyi_status == 0
															? 'red'
															: ''
												}"
											>
												{{ d.会议名称 }}
											</span>
											<span style="color: red; font-size: 13px" v-if="d.huiyi_status == 0">【未开始】</span>
											<span style="color: rgb(153, 153, 153); font-size: 13px" v-else-if="d.huiyi_status == -1">【已结束】</span>
										</div>
										<div style="margin-bottom: 10px">
											<span style="color: #999; font-size: 13px"></span>
											<span style="color: #999; font-size: 13px">{{ d.会议简介 }}</span>
										</div>
										<div style="margin-bottom: 10px">
											<span style="color: #999; font-size: 13px">{{ d.会议开始时间 }}</span>
											<span style="color: #999; font-size: 13px">~</span>
											<span style="color: #999; font-size: 13px">{{ d.会议结束时间 }}</span>
										</div>
										<div style="margin-bottom: 10px">
											<span style="color: #999; font-size: 13px"></span>
											<span style="color: #999; font-size: 13px">{{ d.详细地址 }}</span>
										</div>
									</el-col>
									<el-col :span="3" style="text-align: left">
										<div style="margin-bottom: 10px">
											<span style="color: #999; font-size: 13px">注册(人)：</span>
											<span style="font-weight: bold; font-size: 17px">{{ d.regist_count ? d.regist_count : 0 }}</span>
										</div>
										<div style="margin-bottom: 10px">
											<span style="color: #999; font-size: 13px">签到(人)：</span>
											<span style="color: #999; font-size: 13px">{{ d.sign_count ? d.sign_count : 0 }}</span>
										</div>
										<div style="margin-bottom: 10px">
											<span style="color: #999; font-size: 13px">支付(人)：</span>
											<span style="color: #999; font-size: 13px">{{ d.pay_acount ? d.pay_acount : 0 }}</span>
										</div>
									</el-col>
									<el-col :span="3" style="text-align: left">
										<div style="margin-bottom: 10px">
											<span style="color: #999; font-size: 13px">地址：</span>
											<span style="color: #999; font-size: 13px">{{ d.会议地址 }}</span>
										</div>
										<div style="margin-bottom: 10px">
											<span style="color: #999; font-size: 13px">类型：</span>
											<span style="color: #999; font-size: 13px">{{ d.会议类型 }}</span>
										</div>

										<div style="margin-bottom: 10px">
											<span style="color: #999; font-size: 13px">注册量：</span>
											<span style="color: #999; font-size: 13px">{{ d.注册数量 }}</span>
										</div>
										<!-- <div v-for="(value, key, i) in d" :key="i">
				    <div
				      v-if="
				        key != imgName &&
				        key != 'id' &&
				        key != 'status' &&
				        key != '创建时间' &&
				        key != 'create_dtme' &&
				        key != 'huiyi_status' &&
				        key != 'huiyi_code'
				      "
				      style="height: 25px"
				    >
				      <span
				        v-if="i == 0 ? i == 0 : i == 1"
				        style="font-weight: bold; font-size: 18px"
				        >{{ key }}：</span
				      >
				      <span v-else style="color: #999; font-size: 13px"
				        >{{ key }}：</span
				      >
				      <span
				        v-if="i == 0 ? i == 0 : i == 1"
				        style="font-weight: bold; font-size: 18px"
				        >{{ value }}</span
				      >
				      <span v-else style="color: #999; font-size: 13px">{{
				        value
				      }}</span>
				    </div>
				  </div> -->
									</el-col>
									<!-- <el-col :span="4">
				   <el-progress
				    :text-inside="true"
				    :stroke-width="10"
				    :percentage="70"
				  /> 
				</el-col>-->
									<el-col :span="4" style="text-align: right">
										<div style="margin-bottom: 4px">
											<a-button size="small" v-if="d.status != 0" type="primary" :size="handleBtnSize" style="margin-right: 5px" @click="gotoEvent(d)">
												进入
												<template #icon><EyeOutlined /></template>
											</a-button>
										</div>
										<div style="margin-bottom: 4px">
											<a-button
												size="small"
												v-if="d.status != 0 && d.huiyi_status != -1"
												type="primary"
												:size="handleBtnSize"
												style="margin-right: 5px"
												@click="editEvent(d)"
											>
												编辑
												<template #icon><EditOutlined /></template>
											</a-button>
										</div>
										<div>
											<a-button size="small" v-if="d.status != 0" danger :size="handleBtnSize" style="margin-right: 5px" @click="deleteEvent(d.huiyi_code)">
												删除
												<template #icon><DeleteOutlined /></template>
											</a-button>
										</div>
									</el-col>
								</el-row>
							</a-card>
						</el-col>
					</el-row>

					<!-- 					<a-empty v-else></a-empty> -->

					<el-empty
						v-else
						description="暂无进行中/未开始活动,点击已结束查看已结束活动,
					或点击创建会议,建立新会议"
					/>
				</a-card>
			</el-col>
			<el-col :span="7">
				<el-row>
					<el-col style="margin-bottom: 10px">
						<a-card style="height: 180px">
							<p style="font-weight: bold; color: green">会议数据</p>

							<el-row style="height: 30px">
								<el-col :span="12"><span class="statistic-title">总会议场次</span></el-col>
								<el-col :span="9" style="text-align: right">
									<el-button text link type="primary">{{ statisticInfo.totalEvents }}（场）</el-button>
								</el-col>
							</el-row>

							<el-row style="height: 30px">
								<el-col :span="12"><span class="statistic-title">总注册人数</span></el-col>
								<el-col :span="9" style="text-align: right">
									<el-button text link type="primary">{{ statisticInfo.totalRegists }}（人）</el-button>
								</el-col>
							</el-row>

							<el-row style="height: 30px">
								<el-col :span="12"><span class="statistic-title">单场最大注册人数</span></el-col>
								<el-col :span="9" style="text-align: right">
									<el-button text link type="primary">{{ statisticInfo.maxRegists }}（人）</el-button>
								</el-col>
							</el-row>

							<el-row style="height: 30px">
								<el-col :span="12"><span class="statistic-title">总支付</span></el-col>
								<el-col :span="9" style="text-align: right">
									<el-button text link type="primary">{{ statisticInfo.totalPay }}（￥）</el-button>
								</el-col>
							</el-row>
						</a-card>
					</el-col>
					<el-col style="margin-bottom: 10px">
						<a-card style="height: 240px">
							<p style="font-weight: bold; color: green">权益数据</p>

							<el-row style="height: 50px">
								<el-col :span="12"><span class="statistic-title">短信额度</span></el-col>
								<el-col :span="9" style="text-align: right">
									<span style="margin-right: 20px">{{ statisticInfo.total_sms_num }}</span>
									<el-button text link type="primary" @click="accountTypeShow = true">扩容</el-button>
								</el-col>

								<el-col><el-progress :percentage="statisticInfo.sms_num / statisticInfo.total_sms_num" /></el-col>
							</el-row>

							<el-row style="height: 50px">
								<el-col :span="12"><span class="statistic-title">场次额度</span></el-col>
								<el-col :span="9" style="text-align: right">
									<span style="margin-right: 20px">{{ statisticInfo.registNum }}</span>
									<el-button v-if="this.accountInfo.accountType == 'free'" text link type="primary" @click="accountTypeShow = true">扩容</el-button>
								</el-col>
								<el-col><el-progress :percentage="statisticInfo.registNum / statisticInfo.registNum" /></el-col>
							</el-row>

							<el-row style="height: 50px">
								<el-col :span="12"><span class="statistic-title">注册人数额度</span></el-col>
								<el-col :span="9" style="text-align: right">
									<span style="margin-right: 20px">{{ statisticInfo.registNum }}</span>
									<el-button text link type="primary" @click="accountTypeShow = true">扩容</el-button>
								</el-col>
								<el-col><el-progress :percentage="statisticInfo.registNum / statisticInfo.registNum" /></el-col>
							</el-row>
						</a-card>
						<!-- <el-card style="height: 310px">
							<el-row style="background: #f5f9f8; padding: 10px; margin-bottom: 10px">
								<el-col :span="12">
									<div>
										<p><span>联系客服</span></p>
										<p>
											<span style="font-weight: bold">{{ kefu_number }}</span>
										</p>
									</div>
								</el-col>
								<el-col :span="12" style="text-align: right">
									<img :src="erweimaImg" style="width: 100px" />
								</el-col>
							</el-row>

							<el-row style="background: #f5f9f8; padding: 10px">
								<el-col :span="12">
									<div>
										<p><span>在线咨询</span></p>
									</div>
								</el-col>
								<el-col :span="12"></el-col>
							</el-row>
						</el-card> -->
					</el-col>

					<el-col>
						<a-card style="height: 210px">
							<p style="font-weight: bold; color: green">设置中心</p>
							<el-row style="height: 50px">
								<el-col :span="12"><span class="statistic-title">支付设置</span></el-col>
								<el-col :span="9" style="text-align: right">
									<span>{{ statisticInfo.pay_status == 1 ? '已开启' : '未开启' }}</span>
									<a-button type="link" @click="gotoPaySet">去设置</a-button>
								</el-col>
							</el-row>

							<el-row style="height: 50px">
								<el-col :span="12"><span class="statistic-title">发票设置</span></el-col>
								<el-col :span="9" style="text-align: right">
									<span>{{ statisticInfo.invoice_status == 1 ? '已开启' : '未开启' }}</span>
									<a-button type="link" @click="gotoInvoiceSet">去设置</a-button>
								</el-col>
							</el-row>

							<el-row style="height: 50px">
								<el-col :span="12"><span class="statistic-title">短信设置</span></el-col>
								<el-col :span="9" style="text-align: right">
									<span>{{ statisticInfo.sms_status == 1 ? '已开启' : '未开启' }}</span>

									<a-button type="link" @click="gotoSmsSet">去设置</a-button>
								</el-col>
							</el-row>
						</a-card>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
		<div>
			<el-dialog v-model="accountTypeShow" width="40%" :before-close="handleClose" title="升级版本">
				<div style="height: 400px">
					<el-table :data="tableData" style="width: 100%" border>
						<el-table-column prop="account_type" label="版本" align="center">
							<template v-slot="scope">
								<!-- <span>{{
                  scope.row.account_type == "enterprise" ? "商业版" : "专业版"
                }}</span> -->

								<span class="account-type" v-if="scope.row.account_type == 'enterprise'">
									<el-icon style="color: gold; font-size: 25px; vertical-align: middle"><GoldMedal /></el-icon>
									商业版
								</span>

								<span v-else>专业版</span>
							</template>
						</el-table-column>

						<el-table-column prop="huiyi_num" label="会议场次" align="center" />
						<el-table-column prop="regist_num" label="注册人数" align="center" />
						<el-table-column prop="sms_num" label="短信条数" align="center" />
						<el-table-column prop="fee" label="收费" align="center">
							<template v-slot="scope">
								<span style="color: red; font-weight: bold">{{ scope.row.fee }}</span>
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="" width="140" align="center">
							<template v-slot="scope">
								<div v-if="accountInfo.accountType == 'free'">
									<el-button icon="Upload" type="primary" @click="gotoPay(scope.row.account_type)">确定升级</el-button>
								</div>

								<div v-else-if="accountInfo.accountType == 'professional'">
									<el-button v-if="scope.row.account_type == 'enterprise'" icon="Upload" type="primary" @click="gotoPay(scope.row.account_type)">
										确定升级
									</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-dialog>

			<el-dialog v-model="payShow" width="20%" :before-close="handleClose" title="请扫码付款，付款成功后即可开通">
				<div style="text-align: center">
					<img :src="erweimaImg" style="height: 100px" />
					<div>
						<el-button @click="upAccount" type="primary" style="margin-top: 20px">请扫码付款</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>
<script>
import { myMixin } from './../mixin.js';
const { errorMsgBox, successMsgBox, doConfirm, apiAll, withLoading } = myMixin();
export default {
	data() {
		return {
			accountTypeShow: false,
			payShow: false,
			account_type: '',
			tableData: [
				{
					account_type: 'professional',
					huiyi_num: '不限制',
					regist_num: '500人',
					fee: '3000￥/年',
					sms_num: '1000条'
				},
				{
					account_type: 'enterprise',
					huiyi_num: '不限制',
					regist_num: '1000人',
					fee: '5000￥/年',
					sms_num: '3000条'
				}
			],
			imgName: '会议图片',
			dataList: [],
			page: { startPage: 1, pageSize: 3 },
			erweimaImg: '', // require("../assets/erweima.png"),
			version_desc: '在工作台，您可以预览并查看当前关于账户得主要信息，并快捷进入您想要得操作模块',
			kefu_number: '021-65191840',
			sms_num: 10,
			huiyi_num: 3,
			regist_total: 14,
			sms_num_desc: '',
			sms_num_per: '',
			regist_total_desc: '',
			regist_total_per: '',
			huiyi_num_desc: '',
			huiyi_num_per: '',
			accountInfo: {},
			currentId: '',
			statisticInfo: {
				// eventsMaxNum: '不限制',
				// registNum: 1000,
				// remainDays: 700,
				// doingHuiyi: 0,
				// weekHuiyi: 0,
				// monHuiyi: 0,
				// finishHuiyi: 0,
				// totalEvents: 20,
				// totalRegists: 631,
				// maxRegists: 234,
				// totalPay: 3999,
				// sms_use: 430,
				// sms_info: 10.5,
				// regist_use: 199,
				// huiyi_use: 30
			}
		};
	},
	setup() {},
	created() {
		this.getInit();
	},
	methods: {
		getInit() {
			this.mainHeight = window.innerHeight - 320 + 'px';
			if (window.localStorage.kaola_accountInfo) {
				this.accountInfo = JSON.parse(window.localStorage.kaola_accountInfo);
				// this.regist_total_per = 1;
				// this.regist_total_desc = this.accountInfo.registNum + '/' + this.accountInfo.registNum + '';
				// this.sms_num_desc = this.accountInfo.smsNum + '/' + this.accountInfo.totalSmsNum + '';
				// this.sms_num_per = Math.trunc((this.accountInfo.smsNum / this.accountInfo.totalSmsNum) * 100);
				// this.sms_num_per = (1 / 3) * 100;
			} else {
				this.errorMsgBox('未登录！');
				return false;
			}
			//初始化
			this.getData();
			this.getAdmin();
		},
		gotoPay(account_type) {
			this.payShow = true;
			this.account_type = account_type;
		},
		async getAdmin() {
			let data = {};
			let params = {};
			data.params = JSON.stringify(params);
			const res = await withLoading(apiAll(data, '/getAdmin'));
			if (res.code >= 0) {
				this.statisticInfo = res.extra;
				window.sessionStorage.setItem('kaola_statisticInfo', JSON.stringify(this.statisticInfo));
			} else {
				errorMsgBox(res.message);
			}
		},

		async getData() {
			let data = {};
			let params = {};
			params.page = this.page;
			data.params = JSON.stringify(params);
			const res = await withLoading(apiAll(data, '/getMyEvent'));
			if (res.code >= 0) {
				this.dataList = res.extra.result;
				this.huiyi_num_desc = res.extra.total + '/' + this.accountInfo.huiyiNum;
				this.huiyi_num_per = Math.trunc((res.extra.total / this.accountInfo.huiyiNum) * 100);
				if (this.accountInfo.accountType != 'free') {
					this.huiyi_num_desc = '不限制';
					this.huiyi_num_per = 0;
				}
			} else {
				errorMsgBox(res.message);
			}
		},
		editEvent(row) {
			window.sessionStorage.setItem('huiyiCode', row.huiyi_code);
			this.$router.push('newEvents');
		},
		//进入活动
		gotoEvent(d) {
			sessionStorage.clear();
			window.sessionStorage.setItem('huiyiName', d.会议名称);
			window.open('https://koalahuiyi.com/eventManager?thirdCode=' + d.huiyi_code);
		},
		deleteEvent(id) {
			this.currentId = id;
			doConfirm('确认删除吗，会删除所有相关数据？', this.doDeleteById);
			// this.$confirm('确认删除吗，会删除所有相关数据？')
			// 	.then(() => {
			// 		this.doDeleteById(id);
			// 	})
			// 	.catch(() => {});
		},
		async doDeleteById(id) {
			let data = {};
			let params = {};
			params.ephemeralParam = this.currentId;
			data.params = JSON.stringify(params);
			const res = await withLoading(apiAll(data, '/deleteMyEvent'));
			if (res.code >= 0) {
				successMsgBox(res.message);
				this.getInit();
			} else {
				errorMsgBox(res.message);
			}
		},
		gotoPaySet() {
			window.sessionStorage.removeItem('huiyiCode');
			this.$parent.$parent.$parent.$parent.$parent.$parent.gotoPage('paySet', '支付设置');
		},
		gotoInvoiceSet() {
			window.sessionStorage.removeItem('huiyiCode');
			this.$parent.$parent.$parent.$parent.$parent.$parent.gotoPage('invoice_set', '发票设置');
		},
		gotoSmsSet() {
			window.sessionStorage.removeItem('huiyiCode');
			this.$parent.$parent.$parent.$parent.$parent.$parent.gotoPage('sms_set', '短信设置');
		},
		gotoNewEvents() {
			window.sessionStorage.removeItem('huiyiCode');
			//this.$router.push("newEvents");
			this.$parent.$parent.$parent.$parent.$parent.$parent.gotoPage('newEvents', '创建会议');
		},
		//升级账户，升级完替换account_info和token
		async upAccount() {
			let data = {};
			let params = {};
			params.ephemeralParam = this.account_type;
			data.params = JSON.stringify(params);
			const res = await this.withLoading(this.apiAll(data, '/upAccount'));
			if (res.code >= 0) {
				this.successMsgBox('恭喜您，升级成功！');
				this.accountInfo.huiyiNum = '不限制';
				if (account_type == 'professional') {
					this.accountInfo.registNum = 500;
				} else if (account_type == 'enterprise') {
					this.accountInfo.registNum = 1000;
				}
				this.accountInfo.accountType = this.account_type;
				localStorage.setItem('offical_accountInfo', JSON.stringify(this.accountInfo));
				this.getInit();
			} else {
				errorMsgBox(res.message);
			}
		},

		gotoEvents() {
			this.$parent.$parent.$parent.$parent.$parent.$parent.gotoPage('events', '会议管理');
		}
	}
};
</script>

<style scoped lang="less">
.my-index {
	background: #edf1f4;
	padding: 10px;
	overflow: hidden;
	.statistic-title {
		font-size: 14px;
	}
	.rejectClass {
		z-index: 999;
		position: absolute;
		top: 0;
		//left: 0;
		width: 0;
		height: 0;
		border-top: 49px solid green;
		border-right: 153px solid transparent;
	}
	.rejectSpan {
		position: relative;
		top: -48px;
		left: -17px;
		width: 100px;
		color: #fff;
		font-size: 25px;
		-webkit-transform: scale(0.6);
		transform: scale(0.5);
	}
	.card-header {
		display: flex;
		justify-content: space-between;
		padding: 8px 0;
		align-items: center;
		border-bottom: 1px solid #eee;
	}

	.account-type {
		font-size: 20px;
		color: gold;
		font-weight: bold;
		/* 这里可以随意加样式 */
		background: grey
			linear-gradient(-135deg, transparent 25%, transparent 40%, green 40%, /* 这两个值是滑动条的颜色 */ gold 60%, /* 默认是绿色 自己更改即可 */ transparent 60%, transparent);
		background-size: 160px 160px;
		background-repeat: no-repeat;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		animation: scratchy 3s linear infinite;
	}

	@keyframes scratchy {
		0% {
			background-position: -100% 0;
		}
		100% {
			background-position: 130% 0;
		}
	}
}
</style>
